// extracted by mini-css-extract-plugin
export default {"title":"CaseStudy--title--35m13","video":"CaseStudy--video--3sZ4z","videoHolder":"CaseStudy--videoHolder--Ep7tA"};